import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative h-screen flex items-center justify-center bg-gradient-to-br from-primary-600 to-primary-800">
      <div className="absolute inset-0 bg-black opacity-40"></div>
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-display font-bold mb-6 animate-fade-in">
          {t('hero.title')}
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-gray-100">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/gallery">
            <Button variant="gold" size="lg">
              {t('hero.exploreGallery')}
            </Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" size="lg" className="bg-white bg-opacity-10 border-white text-white hover:bg-white hover:text-primary-600">
              {t('hero.getInTouch')}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
